import React, { useContext, useState } from 'react';
import { ButtonsBlock } from '@src/components/ButtonsBlock';
import { AddLoggerContext } from '@src/AddLogger/AddLoggerContext';
import { useTranslation } from 'react-i18next';
import { Layout } from '@src/components/Layout';
import { Container } from '@src/components/Layout/Container';
import { Title } from '@src/components/Title';
import { useScreen } from '@src/hooks/useScreen';
import { Scanner } from '@src/components/Scanner';
import { useNavigationNoHistory } from '@src/hooks/useNavigationNoHistory';
import { ADD_LOGGER_SCREENS } from '../constant';

export const ScanAssetCode = () => {
    const { t } = useTranslation();
    const navigationNoHistory = useNavigationNoHistory();
    const { isLandscape } = useScreen();
    const { setAsset } = useContext(AddLoggerContext);
    const [code, setCode] = useState(null);

    const navigateToCheckAssetCode = () => {
        navigationNoHistory({
            name: ADD_LOGGER_SCREENS.CHECK_ASSET_CODE,
            fromScreen: ADD_LOGGER_SCREENS.SCAN_ASSET_CODE,
        });
    };

    const onCodeScanned = async () => {
        setAsset(curAsset => ({ ...curAsset, number: code }));
        navigateToCheckAssetCode();
    };

    return (
        <Layout verticalAlign="center">
            {!isLandscape && (
                <Container>
                    <Title>
                        {t('ADD_LOGGER.SCAN_ASSET_CODE')}
                    </Title>
                </Container>
            )}

            <Scanner onCodeScanned={onCodeScanned} code={code} setCode={setCode} />

            <Container>
                {isLandscape && (
                    <Title>
                        {t('ADD_LOGGER.SCAN_ASSET_CODE')}
                    </Title>
                )}
                <ButtonsBlock
                    primaryBtnText={t('COMMON.SCAN')}
                    primaryBtnOnPress={onCodeScanned}
                    isPrimaryBtnDisabled={!code}
                    secondaryBtnText={t('COMMON.ENTER_MANUALLY')}
                    secondaryBtnOnPress={() => navigationNoHistory({ name: ADD_LOGGER_SCREENS.ENTER_ASSET_CODE })}
                />
            </Container>
        </Layout>
    );
};
